import request from "../request";

export const createGrowthGoals = (curriculumId, drId, data) =>
  request.post(`/assessment/${curriculumId}/developmental-rubrics/${drId}/growth-goals`, data).then((res) => res);

export const updateGrowthGoals = (curriculumId, drId, id, data) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/${drId}/growth-goals/${id}`, data).then((res) => res);

export const deleteGrowthGoals = (curriculumId, drId, id) =>
  request.delete(`/assessment/${curriculumId}/developmental-rubrics/${drId}/growth-goals/${id}`).then((res) => res);
